import { Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import Input from "../../../../components/common/inputs/Input";
import Button from "../../../../components/common/button/Button";

const { forwardRef, useRef, useImperativeHandle } = React;

const CourseFeatures = forwardRef(
  ({ featuresData, handleFeatures }, ref) => {
    const [showModal, setShowModal] = useState(false);

    useImperativeHandle(ref, () => ({
      showModal() {
        setShowModal(!showModal);
        window.scrollTo({ top: 0, behavior: "smooth" });
      },
      afterSubmit() {
        setCourseFeatures(null);
      },
    }));

    console.log(featuresData);

    const [courseFeatures, setCourseFeatures] = useState(null);

    const formHandler = async (values, { resetForm }) => {
      handleFeatures(values);
      setShowModal(false);
    };

    useEffect(() => {
      if (featuresData) {
        setCourseFeatures(featuresData);
      }
    }, [featuresData]);

    return (
      <>
        <div
          className={`admin-edit-backdrop fixed top-0 right-0 w-full h-full transition-all z-30  ${
            !showModal && "hidden"
          }`}
        ></div>
        <div
          hidden={!showModal}
          role="dialog"
        aria-label="ویژگی‌های دوره"
          aria-modal="true"
          className={`admin-edit-drawer w-full h-full overflow-y-scroll  bg-white shadow-md z-40 rounded-3xl p-4 transition-all absolute top-0 -left-[120%] ${
            showModal && "!left-0 is-open"
          }`}
        >
          <Formik
            enableReinitialize
            initialValues={{
              courseType: courseFeatures?.courseType || "",
              prerequisite: courseFeatures?.prerequisite || "",
              time: courseFeatures?.time || "",
              sectionCount: courseFeatures?.sectionCount || "",
              fileSize: courseFeatures?.fileSize || "",
            }}
            onSubmit={formHandler}
          >
            {() => (
              <Form>
                <div className="flex w-full items-center justify-between">
                  <h4>ویژگی های دوره</h4>
                  <Button type="submit" color="primary" text="بازگشت" />
                </div>

                <div className="grid gap-6 my-4 md:grid-cols-2">
                  <Input
                    name={"courseType"}
                    placeholder="نوع دوره"
                    label="نوع دوره"
                    type="text"
                  />
                  <Input
                    name={"prerequisite"}
                    placeholder="پیش نیاز"
                    label="پیش نیاز"
                    type="text"
                  />
                  <Input
                    name={"time"}
                    placeholder="مدت زمان"
                    label="مدت زمان"
                    type="text"
                  />
                  <Input
                    name={"sectionCount"}
                    placeholder="تعداد ویدئو"
                    label="تعداد ویدئو"
                    type="text"
                  />
                  <Input
                    name={"fileSize"}
                    placeholder="حجم فایل‌ها"
                    label="حجم فایل‌ها"
                    type="text"
                  />
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </>
    );
  }
);
export default CourseFeatures;
